import React from 'react';

/**
 * Section container wrapper for grouping dashboard modules with clean typography
 */
const Section = ({ title, subtitle, action, children, className = '' }) => {
    return (
        <section className={`mb-8 min-w-0 w-full ${className}`}>
            {(title || subtitle || action) && (
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-5 min-w-0">
                    <div className="min-w-0">
                        {title && (
                            <h2 className="text-lg font-bold text-stone-900 tracking-tight truncate">
                                {title}
                            </h2>
                        )}
                        {subtitle && (
                            <p className="text-xs text-stone-500 font-normal mt-0.5 truncate">
                                {subtitle}
                            </p>
                        )}
                    </div>
                    {action && <div className="flex items-center gap-2 flex-shrink-0">{action}</div>}
                </div>
            )}
            <div className="w-full min-w-0">{children}</div>
        </section>
    );
};

export default Section;
